import { render, staticRenderFns } from "./pages18.vue?vue&type=template&id=dbd5351e&scoped=true&"
import script from "./pages18.vue?vue&type=script&lang=js&"
export * from "./pages18.vue?vue&type=script&lang=js&"
import style0 from "./pages18.vue?vue&type=style&index=0&id=dbd5351e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbd5351e",
  null
  
)

export default component.exports